/* Стили */
import '../css/site.scss';

/* Библиотеки */
import { initAccordion } from './modules/accordion/init-accordion.js';
import { initModal } from './modules/modal/init-modal.js';
import { initTabs } from "./modules/tabs/init-tabs";

/* Модальные окна */
import initModals from './modules/modals/init-modals.js';

/* Скрипты */
import changeDate from './modules/changeDate.js';
import reviews from './modules/reviews.js';
import career from './modules/career.js';
import form from './modules/form.js';
import site from './modules/site.js';
import sliders from './modules/sliders/sliders.js';
import catalogMenuMobile from './modules/catalog.js';
import initShowMoreButton from './modules/init-show-more-button.js';
import UtmTags from './modules/UtmTags.js';
import initRange from './modules/init-range.js';
import bannerBack from './modules/bannerBack.js';
import initMobileMenu from './modules/init-mobile-menu.js';
import { cookieConsentChecker } from './modules/cookies/cookie-consent-checker';
import initUnwrapText from './modules/init-unwrapText.js';
import initChangeDate from './modules/date/index.js';
import coaching from './modules/coaching.js';
import partners from './modules/partners.js';
import initAdvent from './modules/init-advent.js';
import quiz from './modules/quiz.js';
import initQuizCloseButton from './modules/init-quiz-close-button.js';

document.addEventListener('DOMContentLoaded', () => {
    UtmTags();
    initModal();
    initModals();
    initAccordion();
    initTabs();
    changeDate('30 ноября');
    site();
    reviews();
    sliders();
    career();
    form();
    catalogMenuMobile();
    initShowMoreButton("[data-directions]", 8);
    initRange();
    bannerBack();
    initMobileMenu();
    cookieConsentChecker();
    coaching();
    partners();
    initAdvent();
    quiz();
    initQuizCloseButton();
    initChangeDate();
    
    if (window.innerWidth <= 767) {
      setTimeout(() => {
        initUnwrapText();
      }, 1000);
    }
});
